import store from './redux/store';
  const {
    VITE_NODE_ENV,
  } = import.meta.env;

export default function initializePendo(user) {
      const { cartDetails } = store.getState();
      const { oktaUserID } = cartDetails;
    if (!window.pendo) return;
    
    const isProduction = VITE_NODE_ENV === 'production';
    const visitorId = isProduction ? `${oktaUserID}` : `${oktaUserID}_${VITE_NODE_ENV?.toLocaleLowerCase()}`;
    const accountId = isProduction ? `${user?.accountID}` : `${user?.accountID}_${VITE_NODE_ENV?.toLocaleLowerCase()}`;
    
    window.pendo.initialize({
      visitor: {
        id: visitorId || '', // Required
        email: user?.email || '',
        ros_country: user?.ros_country || '',
        ros_region: user?.ros_region || '',
        // full_name: user.name,
        // role: user.role,
      },
      account: {
        id: accountId || '', // Required
        name: user.accountName,
        // planLevel: user.plan,
      },
    });
  }